import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { MobileMenu } from 'components/eventView/layout/MobileMenu';
import { motion } from 'framer-motion';
import { AnimTap2, EFonts, S_IncreaseClick } from 'libs/styles/styling';
import { useAnalytics } from 'libs/utils/site/analytics';
import { useContext } from 'react';
import { useNavigate } from 'react-router';
import { CtxEventView } from 'session/ctxEventView';
import styled from 'styled-components/macro';

interface Props {
    hideRightContainer?: boolean;
    hideLeftContainer?: boolean;
    className?: string;
    children?: React.ReactNode;
}

export const PageHeaderMini = (props: Props) => {
    const ctxEventView = useContext(CtxEventView);
    const { eventData, eventPath } = ctxEventView;

    const navigate = useNavigate();
    const analytics = useAnalytics();

    function navigateBack() {
        const destinationUrl = '/event/' + eventPath;

        analytics.track('event_ui.navigate.clicked', {
            source: 'back',
            destinationUrl: history.length ? '-1' : destinationUrl
        });

        history.length ? navigate(-1) : navigate(destinationUrl);
    }

    return (
        <S_PageHeaderMini
            className={props.className}
            $backgroundImageUrl={eventData.eventInfo.brandImageUrl}
        >
            {!props.hideLeftContainer && (
                <S_Container>
                    <S_ArrowLink onClick={navigateBack} {...AnimTap2}>
                        <S_Arrow
                            $color={ctxEventView.eventData.eventInfo.styling.matchColor}
                            icon={['far', 'arrow-left']}
                        />
                    </S_ArrowLink>
                </S_Container>
            )}
            <S_Children $color={ctxEventView.eventData.eventInfo.styling.matchColor}>
                {props.children}
            </S_Children>
            {!props.hideRightContainer && (
                <S_Container>
                    <S_MobileMenu color={ctxEventView.eventData.eventInfo.styling.matchColor} />
                </S_Container>
            )}
        </S_PageHeaderMini>
    );
};

const S_PageHeaderMini = styled.div<{
    $backgroundImageUrl: string;
}>`
    height: 64px;
    display: flex;
    background-image: url(${(props) => props.$backgroundImageUrl});
    background-size: cover;
`;

const S_Children = styled.div<{ $color: string }>`
    width: 100%;
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    color: ${(props) => props.$color};
    font-family: ${EFonts.InterSemiBold};
    font-size: 15px;
`;

const S_Container = styled.div`
    width: 58px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
`;

const S_ArrowLink = styled(motion(S_IncreaseClick))`
    padding: 10px;
`;

const S_Arrow = styled(FontAwesomeIcon)<{ $color: string }>`
    font-size: 20px;
    color: ${(props) => props.$color};
`;

const S_MobileMenu = styled(MobileMenu)``;
